import script from "./AssetCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetCategories.vue?vue&type=script&setup=true&lang=js"

import "./AssetCategories.vue?vue&type=style&index=0&id=789576b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-789576b2"]])

export default __exports__